module.exports = __webpack_public_path__ + "static/media/buildingConstruction9.a35c94e8.jpg";